module.exports = __webpack_public_path__ + "img/Makeup5.3f222616.jpg";